import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const OrderTableExpandIcon = (props: any) => {
  if (props.expanded) {
    return (
      <a
        style={{ color: "black" }}
        onClick={(e) => {
          props.onExpand(props.record, e)
        }}
        className="!max-w-[10px]"
      >
        <FontAwesomeIcon
          className="flex-shrink-0 h-4 text-gray-400 text-sm self-start"
          icon={faAngleDown}
        />
      </a>
    )
  } else {
    return (
      <a
        style={{ color: "black" }}
        onClick={(e) => {
          props.onExpand(props.record, e)
        }}
        className="px-0.5 !max-w-[10px]"
      >
        <FontAwesomeIcon className="flex-shrink-0 h-4 text-gray-400 text-sm" icon={faAngleRight} />
      </a>
    )
  }
}

export default OrderTableExpandIcon
